
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '@/data/blogData';
import { Calendar, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const BlogList = () => {
  const [visiblePosts, setVisiblePosts] = useState(4);

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const loadMorePosts = () => {
    setVisiblePosts(prev => Math.min(prev + 4, blogPosts.length));
  };

  return (
    <div className="space-y-12">
      {blogPosts.slice(0, visiblePosts).map((post, index) => (
        <article key={post.slug} className={`border-b border-gray-200 pb-12 ${index === 0 ? 'mb-8' : ''}`}>
          <Link to={`/blog/${post.slug}`} className="block">
            <div className="mb-6 rounded-lg overflow-hidden">
              <img 
                src={post.image} 
                alt={post.title} 
                className="w-full h-64 object-cover transition-transform duration-300 hover:scale-105"
              />
            </div>
          </Link>
          
          <div className="flex items-center gap-4 mb-4">
            <Badge variant="secondary" className="bg-pkgreen-100 text-pkgreen-700 hover:bg-pkgreen-200">
              {post.category}
            </Badge>
            <div className="flex items-center text-gray-500 text-sm">
              <Calendar className="h-4 w-4 mr-1" />
              {formatDate(post.date)}
            </div>
          </div>
          
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-3 hover:text-pkgreen-600 transition-colors">
            <Link to={`/blog/${post.slug}`}>
              {post.title}
            </Link>
          </h2>
          
          <p className="text-gray-700 mb-4 line-clamp-3">
            {post.excerpt}
          </p>
          
          <Link 
            to={`/blog/${post.slug}`} 
            className="inline-flex items-center text-pkgreen-600 font-medium hover:text-pkgreen-700 transition-colors"
          >
            Read More
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </article>
      ))}
      
      {visiblePosts < blogPosts.length && (
        <div className="text-center pt-4">
          <Button 
            onClick={loadMorePosts} 
            variant="outline"
            className="border-pkgreen-500 text-pkgreen-600 hover:bg-pkgreen-50"
          >
            Load More Articles
          </Button>
        </div>
      )}
    </div>
  );
};

export default BlogList;
